<wl-busy [show]="isLoading"></wl-busy>

<wl-notification-banner
  *ngIf="loadError"
  class="mb-20"
  [translationKey]="'revenue.gateway-resolution-tree.graph-load-error'"
></wl-notification-banner>

<p *ngIf="!hasStart" class="light-text gateway-resolution-graph-empty">
  {{ 'revenue.gateway-resolution-tree.graph-empty' | translate }}
</p>

<p *ngIf="hasStart && !isLoading && !loadError && !hasGraph" class="light-text">
  {{ 'revenue.gateway-resolution-tree.graph-no-nodes' | translate }}
</p>

<div class="gateway-resolution-graph-body">
<div class="gateway-resolution-graph-wrapper" [hidden]="!hasGraph || loadError">
  <svg class="gateway-resolution-graph-rings" aria-hidden="true">
    <g *ngFor="let g of ringGuides">
      <circle [attr.cx]="g.cx" [attr.cy]="g.cy" [attr.r]="g.r"></circle>
      <text [attr.x]="g.labelX" [attr.y]="g.labelY" text-anchor="middle">{{ g.labelKey | translate | titlecase }}</text>
    </g>
  </svg>
  <div #cyContainer class="gateway-resolution-graph-canvas"></div>
  <div *ngIf="hoverLabel" class="gateway-resolution-graph-hover" [style.left.px]="hoverLabel.x" [style.top.px]="hoverLabel.y">
    <ng-container *ngIf="hoverLabel.count == null; else moreLabel">{{ hoverLabel.text }}<ng-container *ngIf="hoverLabel.missing"> {{ 'revenue.gateway-resolution-tree.graph-not-found' | translate }}</ng-container></ng-container>
    <ng-template #moreLabel>{{ 'revenue.gateway-resolution-tree.graph-more-items' | translate: { count: hoverLabel.count } }}</ng-template>
  </div>
</div>

<div class="gateway-resolution-graph-legend" *ngIf="hasGraph && !loadError">
  <span *ngFor="let l of legend" class="gateway-resolution-graph-legend-entry flx-layout-row flx-align-start-center flx-gap-8px">
    <span class="gateway-resolution-graph-swatch {{ l.colourClass }}"></span>
    <i [class]="l.icon"></i>
    <span>{{ l.key | translate | titlecase }}</span>
  </span>
  <span *ngFor="let l of legendStyles" class="gateway-resolution-graph-legend-entry flx-layout-row flx-align-start-center flx-gap-8px">
    <span class="gateway-resolution-graph-swatch {{ l.colourClass }}"></span>
    <span>{{ l.key | translate | titlecase }}</span>
  </span>
</div>
</div>

<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top"
  [(visible)]="showDialog"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <h4>
      <span class="{{ selectedNode?.icon }} mr-8"></span>
      {{ selectedNode?.label }}
    </h4>
  </ng-template>

  <div class="atlas-form flx-layout-column flx-gap-27px" *ngIf="selectedNode">
    <div *ngIf="selectedNode.flags?.isMissing || selectedNode.flags?.noDefaultPaymentType || selectedNode.flags?.noPackage" class="gateway-resolution-graph-flags flx-layout-column flx-gap-8px">
      <div *ngIf="selectedNode.flags?.isMissing" class="gateway-resolution-graph-flag">{{ 'revenue.gateway-resolution-tree.graph-not-found' | translate }}</div>
      <div *ngIf="selectedNode.flags?.noDefaultPaymentType" class="gateway-resolution-graph-flag">{{ 'revenue.gateway-resolution-tree.graph-no-default-payment-type' | translate }}</div>
      <div *ngIf="selectedNode.flags?.noPackage" class="gateway-resolution-graph-flag">{{ 'revenue.gateway-resolution-tree.graph-no-package' | translate }}</div>
    </div>
    <ng-container [ngSwitch]="selectedNode.type">

      <!-- Revenue Item -->
      <ng-container *ngSwitchCase="'item'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.item-num' | translate }}</label><div>{{ selectedNode.data['id'] }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.accounting-package-id' | translate }}</label><div>{{ selectedNode.data['accountingPackageId'] ?? '—' }}</div></div>
        </div>
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.description' | translate }}</label><div>{{ selectedNode.data['description'] || '—' }}</div></div>
      </ng-container>

      <!-- Accounting Package -->
      <ng-container *ngSwitchCase="'accountingPackage'">
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.package-id' | translate }}</label><div>{{ selectedNode.data['id'] }}</div></div>
        <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.name' | translate }}</label><div>{{ selectedNode.data['name'] || '—' }}</div></div>
      </ng-container>

      <!-- Payment Type -->
      <ng-container *ngSwitchCase="'paymentType'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.payment-type-id' | translate }}</label><div>{{ selectedNode.data['id'] }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-id' | translate }}</label><div>{{ selectedNode.data['ccGatewayId'] ?? '—' }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.credit-card' | translate }}</label><div>{{ selectedNode.data['isCC'] == null ? '—' : (selectedNode.data['isCC'] ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.ach' | translate }}</label><div>{{ selectedNode.data['isACH'] == null ? '—' : (selectedNode.data['isACH'] ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.name' | translate }}</label><div>{{ selectedNode.data['name'] || '—' }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.graph-default-for-package' | translate }}</label><div>{{ selectedNode.data['isDefaultForPackage'] == null ? '—' : (selectedNode.data['isDefaultForPackage'] ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
        </div>
      </ng-container>

      <!-- CC Gateway -->
      <ng-container *ngSwitchCase="'gateway'">
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-id' | translate }}</label><div>{{ selectedNode.data['id'] }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.gateway-type' | translate }}</label><div>{{ selectedNode.data['gatewayTypeName'] || selectedNode.data['gatewayTypeId'] || '—' }}</div></div>
        </div>
        <div class="flx-gd-cols-1fr-1fr">
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.name' | translate }}</label><div>{{ selectedNode.data['name'] || '—' }}</div></div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.sandbox' | translate }}</label><div>{{ selectedNode.data['isSandbox'] == null ? '—' : (selectedNode.data['isSandbox'] ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
        </div>
        <ng-container *ngIf="gatewayExtras || gatewayExtrasUnavailable; else extrasLoading">
          <div class="flx-gd-cols-1fr-1fr">
            <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.momentive-payments-echeck' | translate }}</label><div>{{ gatewayExtras?.precznECheck == null ? '—' : (gatewayExtras?.precznECheck ? ('common.yes' | translate) : ('common.no' | translate)) }}</div></div>
            <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.momentive-payments-merchant-id' | translate }}</label><div>{{ gatewayExtras?.precznMerchantId || '—' }}</div></div>
          </div>
          <div><label class="light-text">{{ 'revenue.gateway-resolution-tree.cardpointe-merchant-id' | translate }}</label><div>{{ gatewayExtras?.cardConnectMerchId || '—' }}</div></div>
        </ng-container>
        <ng-template #extrasLoading><wl-busy [show]="true"></wl-busy></ng-template>
      </ng-container>

    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="flx-layout-row flx-wrap-nowrap flx-align-end-center">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="closeDialog()">
        {{ 'common.close' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
